module.exports = __webpack_public_path__ + "static/media/bw-d2.44e24cba.svg";